/**
 * Breakpoints configuration for responsive props
 *
 * Single source of truth for all breakpoint names, values, and ordering.
 * The type and ordering array are derived automatically from this constant.
 */

// Order here is important for the responsive plugin
/* eslint-disable perfectionist/sort-objects */
export const BREAKPOINTS = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px",
} as const;

/** Ordered array of breakpoint names, smallest to largest */
export const BREAKPOINT_ORDER = Object.keys(BREAKPOINTS) as (keyof typeof BREAKPOINTS)[];
